import { PropsWithChildren, useEffect } from "react";
import { useRouteParamNumber } from "lib/hooks/useRouteParam";

import { setAsRecentProject } from "../../actions/recentProjects/setAsRecentProject";

export const RecentProjectsStorageProvider = (p: PropsWithChildren<{}>) => {
  const [projectId] = useRouteParamNumber("projectId");

  // Save user's recent accessed project to local storage
  useEffect(() => {
    if (projectId) {
      setAsRecentProject(projectId);
    }
  }, [projectId]);

  return <>{p.children}</>;
};
